import React from 'react';
import { Link } from 'react-router-dom';
import LegalLayout, { L } from './LegalLayout';
import { OPERATOR } from '../../legal/operator';

export default function LegalHubPage() {
  return (
    <LegalLayout title="Legal">
      <L.P>
        Everything you need to know about how {OPERATOR.productName} handles your data, what you can
        and can't do with the Service, and which third parties help us run it.
      </L.P>

      <div style={grid}>
        <DocCard to="/privacy"       title="Privacy Policy"     desc="What data we collect and what we do with it." />
        <DocCard to="/terms"         title="Terms of Service"   desc="The rules for using Inverow, plus our disclaimers." />
        <DocCard to="/cookies"       title="Cookies"            desc="What we store in your browser and why." />
        <DocCard to="/subprocessors" title="Subprocessors"      desc="Third-party services that process your data on our behalf." />
      </div>

      <L.P style={{ marginTop: '20px' }}>
        Any questions? Write to <L.Mail to={OPERATOR.supportEmail} />.
      </L.P>
    </LegalLayout>
  );
}

function DocCard({ to, title, desc }) {
  return (
    <Link to={to} style={card}>
      <div style={cardTitle}>{title}</div>
      <div style={cardDesc}>{desc}</div>
    </Link>
  );
}

const grid     = { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '12px', marginTop: '8px' };
const card     = { display: 'block', padding: '18px 18px', borderRadius: '14px', border: '1px solid var(--border)', background: 'var(--surface-strong)', textDecoration: 'none', color: 'var(--text-primary)' };
const cardTitle= { fontWeight: 800, fontSize: '16px', marginBottom: '6px' };
const cardDesc = { color: 'var(--text-secondary)', fontSize: '13px', lineHeight: 1.5 };
